// =====================================================================
// Scent Finder – GSAP Draggable + InertiaPlugin
// =====================================================================
(function () {
  'use strict';

  if (typeof gsap !== 'undefined' && typeof Draggable !== 'undefined') {
    gsap.registerPlugin(Draggable, InertiaPlugin);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const dragArea    = document.getElementById('scent-drag-area');
    const dragBg      = document.getElementById('scent-drag-bg');
    const scentFinder = document.querySelector('.scent-finder');
    const drawer      = document.getElementById('sf-drawer');
    const drawerBody  = document.getElementById('sf-drawer-body');
    const drawerClose = document.getElementById('sf-drawer-close');
    const backdrop    = document.getElementById('sf-drawer-backdrop');
    const overlay     = document.getElementById('sf-initial-overlay');
    const sfMeta      = document.getElementById('sf-meta');

    if (!dragArea || !scentFinder) return;

    // ── Desktop media query (declared early – used by getBounds) ──
    const desktopMQ = window.matchMedia('(min-width: 1024px)');

    // ── Helpers: bounds ──
    function getBounds() {
      // When the drawer is open on desktop we allow the drag area to shift
      // up to +50vw rightward so left-side blocks can appear in the visible half.
      var maxX = (desktopMQ && desktopMQ.matches && drawer && drawer.classList.contains('is-open'))
                   ? window.innerWidth / 2
                   : 0;
      return {
        minX: -(dragArea.offsetWidth  - scentFinder.offsetWidth),
        maxX: maxX,
        minY: -(dragArea.offsetHeight - scentFinder.offsetHeight),
        maxY: 0
      };
    }

    // ── Position drag area in the centre, then reveal ──
    const centreX = -window.innerWidth  * 0.5;
    const centreY = -window.innerHeight * 0.5;
    gsap.set([dragArea, dragBg].filter(Boolean), { x: centreX, y: centreY });

    // Reveal once positioned and labels are placed
    requestAnimationFrame(function () {
      scentFinder.classList.add('is-ready');
      if (!overlayDismissed) scentFinder.classList.add('has-overlay');
    });

    // ── Overlay: fade on first interaction ──
    let overlayDismissed = false;
    function dismissOverlay() {
      if (overlayDismissed) return;
      overlayDismissed = true;
      // Inline transition + rAF guarantees the fade regardless of CSS load state
      if (overlay) {
        scentFinder.classList.remove('has-overlay');
        overlay.style.transition = 'opacity 1s ease';
        requestAnimationFrame(function () {
          overlay.style.opacity = '0';
          overlay.style.pointerEvents = 'none';
        });
      }
      if (sfMeta) {
        sfMeta.style.transition = 'opacity 1s ease';
        requestAnimationFrame(function () {
          sfMeta.style.opacity = '0';
        });
      }
    }

    // Overlay has pointer-events: auto – it captures the very first interaction
    if (overlay) {
      overlay.addEventListener('pointerdown', function () {
        dismissOverlay();
      });
    }

    // ── Overlay: re-appear (fade in) when user leaves the tab/window ──
    function showOverlay() {
      if (!overlay || drawer.classList.contains('is-open')) return;
      overlayDismissed = false;

      // Reset drawer state (classes + URL only – no GSAP position tween,
      // which would race against the overlay transition below).
      // if (drawer && drawer.classList.contains('is-open')) {
      //   drawer.classList.remove('is-open');
      //   blocks.forEach(function (b) { b.classList.remove('is-active'); });
      //   scentFinder.classList.remove('drawer-active');
      //   backdrop.classList.remove('is-visible');
      //   document.body.style.overflow = '';
      //   clearScentParam();
      //   draggable.applyBounds(getBounds());
      // }
      scentFinder.classList.add('has-overlay');
      overlay.style.transition = 'opacity 1s ease';
      requestAnimationFrame(function () {
        overlay.style.opacity = '0.3';
      });
      if (sfMeta) {
        sfMeta.style.transition = 'opacity 1s ease';
        requestAnimationFrame(function () {
          sfMeta.style.opacity = '1';
        });
      }
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) showOverlay();
    });

    // ── Draggable ──
    let dragged = false;

    const draggable = Draggable.create(dragArea, {
      type: 'x,y',
      cursor: 'grab',
      activeCursor: 'grabbing',
      bounds: getBounds(),
      inertia: true,
      force3D: true,
      dragResistance: 0.25,
      throwResistance: 5000,
      maxDuration: 1.3,
      minDuration: 0.8,
      zIndexBoost: false,
      overshootToleranceIndex: 0,
      onPress: function () {
        dragged = false;
        dismissOverlay();
      },
      onDrag: function () {
        dragged = true;
        if (dragBg) gsap.set(dragBg, { x: this.x, y: this.y });
      },
      onThrowUpdate: function () {
        if (dragBg) gsap.set(dragBg, { x: this.x, y: this.y });
      },
      onDragEnd: function () {
        if (dragBg) gsap.set(dragBg, { x: this.x, y: this.y });
      }
    })[0];
    // Recalculate bounds on resize
    window.addEventListener('resize', function () {
      draggable.applyBounds(getBounds());
    });

    // ── Scroll-to-pan: wheel scrolls (and trackpad swipes) move the drag area ──
    dragArea.addEventListener('wheel', function (e) {
      e.preventDefault();
      dismissOverlay();
      var curX = gsap.getProperty(dragArea, 'x');
      var curY = gsap.getProperty(dragArea, 'y');
      var b    = getBounds();
      var newX = Math.max(b.minX, Math.min(b.maxX, curX - e.deltaX));
      var newY = Math.max(b.minY, Math.min(b.maxY, curY - e.deltaY));
      gsap.to([dragArea, dragBg].filter(Boolean), {
        x: newX, y: newY,
        duration: 0.1,
        ease: 'power2.out',
        overwrite: 'auto',
        onUpdate: function () { draggable.update(); }
      });
    }, { passive: false });

    // ── Block click → open drawer ──
    const blocks = dragArea.querySelectorAll('.scent-finder__block');
    blocks.forEach(function (block) {
      block.addEventListener('click', function (e) {
        e.stopPropagation();
        if (dragged) return;
        dismissOverlay();
        openDrawer(block.getAttribute('data-val'), block);
      });
    });

    // ── Center active block in the right 50vw visible area ──
    // The viewport stays 100vw always; the drawer overlays the left 50vw.
    // We pan the drag area so the block lands at the center of the right half.
    // When the drawer is open we temporarily allow x > 0 (up to +50vw) so
    // left-side blocks can shift into the visible right half.
    function centerBlockInView(block) {
      var viewW = window.innerWidth;
      var viewH = window.innerHeight;
      var b  = getBounds(); // maxX is already +50vw when drawer is open
      var cx = Math.max(b.minX, Math.min(b.maxX, viewW * 0.75 - block.offsetLeft));
      var cy = Math.max(b.minY, Math.min(b.maxY, viewH * 0.5  - block.offsetTop));
      gsap.killTweensOf([dragArea, dragBg].filter(Boolean));
      draggable.applyBounds(getBounds());
      gsap.to([dragArea, dragBg].filter(Boolean), {
        x: cx, y: cy, duration: 0.7, ease: 'power2.inOut',
        onUpdate: function () { draggable.update(); }
      });
    }

    // ── URL param helpers ──
    function setScentParam(val) {
      var url = new URL(window.location);
      url.searchParams.set('scent', val);
      history.replaceState(null, '', url);
    }
    function clearScentParam() {
      var url = new URL(window.location);
      url.searchParams.delete('scent');
      history.replaceState(null, '', url);
    }

    // ── Drawer helpers ──
    function openDrawer(val, activeBlock) {
      var activePanel = null;
      var panels = drawerBody.querySelectorAll('.sf-drawer__panel');
      panels.forEach(function (p) {
        if (p.getAttribute('data-val') === val) {
          p.style.display = 'block';
          activePanel = p;
        } else {
          p.style.display = 'none';
        }
      });
      drawer.classList.add('is-open');
      blocks.forEach(function (b) { b.classList.remove('is-active'); });
      if (activeBlock) activeBlock.classList.add('is-active');

      // Initialise/refresh the slider in the newly-visible panel only
      swiperCard(activePanel);

      // Update URL
      setScentParam(val);

      if (desktopMQ.matches) {
        // Viewport stays 100vw – just mark active state and pan to right half.
        scentFinder.classList.add('drawer-active');
        if (activeBlock) centerBlockInView(activeBlock);
      } else {
        backdrop.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      }
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      blocks.forEach(function (b) { b.classList.remove('is-active'); });
      scentFinder.classList.remove('drawer-active');
      backdrop.classList.remove('is-visible');
      document.body.style.overflow = '';
      clearScentParam();

      if (desktopMQ.matches) {
        // Animate drag area back into normal bounds (x ≤ 0) in case it was
        // shifted right to reveal a left-side block. Matches drawer slide duration.
        var b     = getBounds(); // maxX: 0
        var curX  = gsap.getProperty(dragArea, 'x');
        var curY  = gsap.getProperty(dragArea, 'y');
        var normX = Math.min(0, curX); // clamp positive x back to 0
        var normY = Math.max(b.minY, Math.min(b.maxY, curY));
        if (curX !== normX || curY !== normY) {
          gsap.killTweensOf([dragArea, dragBg].filter(Boolean));
          gsap.to([dragArea, dragBg].filter(Boolean), {
            x: normX, y: normY, duration: 0.7, ease: 'power2.inOut',
            onComplete: function () { draggable.applyBounds(getBounds()); }
          });
        } else {
          draggable.applyBounds(getBounds());
        }
      } else {
        draggable.applyBounds(getBounds());
      }
    }

    drawerClose.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // ── Desktop: click on the right 50vw area closes the drawer ──
    scentFinder.addEventListener('click', function () {
      if (!desktopMQ.matches) return;
      if (!drawer.classList.contains('is-open')) return;
      if (dragged) return;
      closeDrawer();
    });

    // ── Deep-link: open drawer if ?scent= param is present on load ──
    (function handleDeepLink() {
      var params = new URLSearchParams(window.location.search);
      var scentVal = params.get('scent');
      if (!scentVal) return;

      // Find matching block
      var matchedBlock = null;
      blocks.forEach(function (b) {
        if (b.getAttribute('data-val') === scentVal) matchedBlock = b;
      });
      if (!matchedBlock) return;

      // Skip overlay entirely
      overlayDismissed = true;
      if (overlay) {
        scentFinder.classList.remove('has-overlay');
        overlay.style.opacity = '0';
        overlay.style.pointerEvents = 'none';
      }
      if (sfMeta) {
        sfMeta.style.opacity = '0';
      }

      // Open drawer immediately (no animation needed on first paint)
      openDrawer(scentVal, matchedBlock);
    })();
  });
})();


function swiperCard(container) {
  const root = (container instanceof Element) ? container : document;
  root.querySelectorAll('.ph-slider').forEach((slider) => {
    if (slider.querySelectorAll('.swiper-slide').length <= 1) return;
    if (slider.swiper) {
      slider.swiper.update();
    } else {
      new Swiper(slider, {
        loop: false,
        spaceBetween: 12,
        breakpoints: {
          320: {
            slidesPerView: 2.15,
            direction: 'horizontal'
          },
          1024: {
            slidesPerView: 'auto',
            direction: 'vertical',
            slidesOffsetAfter: 65,
            mousewheel: {
              enabled: true,
              sensitivity: 0.3
            },
            freeMode: true
          },
        }
      });
    }
  });
}